import firebase from "firebase";
import {deserialize, serialize} from "serializr";
import {ConfigModel} from "@/modules/mconfigs/models/ConfigModel";
import {Metadata} from "@/common/Metadata";
import {MergeHistoryModel} from "@/modules/mconfigs/models/MergeHistoryModel";
import {uuid} from "vue-uuid";
import {TimeUtils} from "@/common/TimeUtils";
import {FolderModel} from "@/modules/mconfigs/models/FolderModel";

export default {
    namespaced: true,
    state: {
        mUser: "",
        mConfigs: [],
        mFolders: [],
        mReleaseConfigs: [],
        mMasterConfigs: [],
        mMergeHistory: [],
        mSharedConfigs: []
    },
    getters: {
        getMergeHistory: state => {
            return state.mMergeHistory;
        },
        getConfigs: state => {
            return state.mConfigs;
        },
        getFolders: state => {
            return state.mFolders;
        },
        getReleaseConfigs: state => {
            return state.mReleaseConfigs;
        },
        getMasterConfigs: state => {
            return state.mMasterConfigs;
        },
        getSharedConfigs: state => {
            return state.mSharedConfigs;
        }
    },
    mutations: {
        setMergeHistory(state, values) {
            state.mMergeHistory = values;
        },
        setConfigs(state, values) {
            state.mConfigs = values;
        },
        setFolders(state, values) {
            state.mFolders = values;
        },
        updateConfig(state, value) {
            let index = state.mConfigs.findIndex(v => {
                return v.uid === value.uid;
            });

            if (index >= 0) {
                state.mConfigs.splice(index, 1, value);
            } else {
                state.mConfigs.push(value);
            }
        },
        deleteConfig(state, uid) {
            let index = state.mConfigs.findIndex(v => {
                return v.uid === uid;
            });

            if (index >= 0) {
                state.mConfigs.splice(index, 1);
            }
        },
        deleteConfigs(state, uids) {
            state.mConfigs = state.mConfigs.filter(v => {
                return !uids.includes(v.uid);
            });
        },
        setReleaseConfigs(state, values) {
            state.mReleaseConfigs = values;
        },
        updateReleaseConfig(state, value) {
            let index = state.mReleaseConfigs.findIndex(v => {
                return v.uid === value.uid;
            });

            if (index >= 0) {
                state.mReleaseConfigs.splice(index, 1, value);
            } else {
                state.mReleaseConfigs.push(value);
            }
        },
        setMasterConfigs(state, values) {
            state.mMasterConfigs = values;
        },
        updateMasterConfig(state, value) {
            let index = state.mMasterConfigs.findIndex(v => {
                return v.uid === value.uid;
            });

            if (index >= 0) {
                state.mMasterConfigs.splice(index, 1, value);
            } else {
                state.mMasterConfigs.push(value);
            }
        },
        removeReleaseConfig(state, uid) {
            let index = state.mReleaseConfigs.findIndex(v => {
                return v.uid === uid;
            });

            if (index >= 0) {
                state.mReleaseConfigs.splice(index, 1);
            }
        },
        setSharedConfigs(state, values) {
            state.mSharedConfigs = values;
        },
        updateSharedConfig(state, value) {
            let index = state.mSharedConfigs.findIndex(v => v.uid === value.uid);
            if (index >= 0) {
                state.mSharedConfigs.splice(index, 1, value);
            } else {
                state.mSharedConfigs.push(value);
            }
        },
        removeSharedConfig(state, uid) {
            let index = state.mSharedConfigs.findIndex(v => v.uid === uid);
            if (index >= 0) {
                state.mSharedConfigs.splice(index, 1);
            }
        }
    },
    actions: {
        init({commit}) {
            console.info('config-store initialized.');

            let user = firebase.auth().currentUser;
            let db = firebase.database();

            return Promise.all([
                db.ref("/release")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        let values = data.map(v => deserialize(ConfigModel, v));
                        commit("setReleaseConfigs", values);
                    }),
                db.ref("/master")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        let values = data.map(v => deserialize(ConfigModel, v));
                        commit("setMasterConfigs", values);
                    }),
                db.ref("/folders")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        let values = data.map(v => deserialize(FolderModel, v));
                        commit("setFolders", values);
                    }),
                db.ref("/shared_configs")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        let values = data.map(v => deserialize(ConfigModel, v));
                        commit("setSharedConfigs", values);
                    }),
                db.ref("users/" + user.uid + "/configs")
                    .once("value")
                    .then((snapshot) => {
                        let data = snapshot.val() || [];
                        if (data.length != 0){
                            let promises = data.map(v => {
                                return db.ref("/configs/" + v)
                                    .once("value")
                                    .then((snapshot) => {
                                        if (snapshot.val()) {
                                            commit("updateConfig", deserialize(ConfigModel, snapshot.val()));
                                        }
                                        return Promise.resolve()
                                    });
                            });
                            return Promise.all(promises);
                        }else{
                            // return db.ref("/def")
                            //     .once("value")
                            //     .then((snapshot) => {
                            //         if (snapshot.val()) {
                            //             let name = "copy_of_def"
                            //             let model = new ConfigModel(name, snapshot.val());
                            //             model.tag = name
                            //             return ConfigStoreUtils.pushConfig(model)
                            //         }
                            //     });
                        }
                    })
            ]);
        },

        //TMP
        // validate({/*commit*/}, value) {
        //     let db = firebase.database();
        //     let configs = []
        //     return Promise.all([
        //         db.ref("users")
        //         .once("value")
        //         .then((snapshot) => {
        //             let data = snapshot.val() || [];
        //             for (let user in data){
        //                 for (let c in data[user].configs){
        //                     configs.push(data[user].configs[c])
        //                 }
        //             }
        //             console.log(configs, configs.length)
        //         })
        //     ]);
        // },
        removeData({/*commit*/}, value) {
            let db = firebase.database();
            var toRemove = {}
            return Promise.all([
                db.ref("/release")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        for (let d in data){
                            toRemove["/release/" + data[d].uid + "/data"] = null
                        }
                    }),
                db.ref("/configs")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        for (let d in data){
                            toRemove["/configs/" + data[d].uid + "/data"] = null
                        }
                        var c = []
                        for (let i in toRemove){
                            c.push(db.ref(i).remove())
                        }
                        return Promise.all(c)
                    }),
            ]);
        },
        copyData({/*commit*/}, value) {
            let db = firebase.database();
            var finalData = {}
            return Promise.all([
                db.ref("/release")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        for (let d in data){
                            finalData[data[d].uid] = data[d].data || null
                        }
                    }),
                db.ref("/configs")
                    .once("value")
                    .then((snapshot) => {
                        let data = Object.values(snapshot.val() || {});
                        for (let d in data){
                            finalData[data[d].uid] = data[d].data || null
                        }
                        var c = []
                        for (let i in finalData){
                            c.push(db.ref("configs_data/" + i).update(finalData[i]))
                        }
                        return Promise.all(c)
                    }),
            ]);
        },
        getConfigData({/*commit*/}, path) {
            return firebase.database()
                .ref(path)
                .once("value")
                .then((snapshot) => {
                    return snapshot.val();
                })
        },
        pushConfig({commit}, value) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            value.config.meta = new Metadata(user.uid);
            let data = serialize(ConfigModel, value.config);
            return Promise.all([
                db.ref("/configs/" + value.config.uid)
                .set(data)
                .then(() => {
                    commit("updateConfig", value.config);
                    let ref = db.ref("users/" + user.uid + "/configs");
                    return ref.once("value")
                    .then((snapshot) => {
                        let list = snapshot.val() || [];
                        if (list.indexOf(value.config.uid) < 0) {
                            list.push(value.config.uid);
                            return ref.set(list);
                        }
                    });
                }),
                db.ref("/configs_data/" + value.config.uid)
                .set(value.data)
                .then(() => {})
            ])
        },
        pushMergeHistory({/*commit*/}, value) {
            let db = firebase.database();
            let all = []
            all.push(
                db.ref("/merge_history/merge_list/" + uuid.v4().replace(/-/g, ""))
                .set(serialize(MergeHistoryModel, value.historyModel))
                .then(() => {
                    return Promise.resolve()
                })
            )
            for (let i in value.datas){
                let obj = value.datas[i];
                all.push(
                    db.ref("/merge_history/merge_data/" + obj.data_path)
                    .set(obj.data_content)
                    .then(() => {
                        return Promise.resolve()
                    })
                )
            }
            return Promise.all(all);
        },
        pushMasterConfig({commit}, value) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            value.config.meta = new Metadata(user.uid);
            let data = serialize(ConfigModel, value.config);
            return Promise.all([
                db.ref("/master/" + value.config.uid)
                    .set(data)
                    .then(() => {
                        console.log(value.config)
                        commit("updateMasterConfig", value.config);
                    }),
                db.ref("/configs_data/" + value.config.uid)
                    .set(value.data)
                    .then(() => {

                    })
            ])
        },
        updateConfig({commit}, config) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            config.meta = new Metadata(user.uid);
            let data = serialize(ConfigModel, config);
            return Promise.all([
                db.ref("/configs/" + config.uid)
                .set(data)
                .then(() => {
                    commit("updateConfig", config);
                })
            ])
        },
        deleteConfig({commit}, uid) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            let ref = db.ref("users/" + user.uid + "/configs");
            return Promise.all([
                db.ref("/configs/" + uid)
                    .remove()
                    .then(() => {
                        commit("deleteConfig", uid);
                    }),
                db.ref("/configs_data/" + uid)
                    .remove()
                    .then(() => {
                        console.log('data deleted: ', uid)
                    }),
                ref.once("value")
                    .then((snapshot) => {
                        let list = snapshot.val() || [];
                        let index = list.indexOf(uid);
                        if (index => 0) {
                            list.splice(index, 1);
                            return ref.set(list);
                        }
                    })
            ]);
        },
        deleteConfigs({commit}, uids) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            let ref = db.ref("users/" + user.uid + "/configs");
            let promises = uids.map(uid => {
                return Promise.all([
                    db.ref("/configs/" + uid)
                        .remove()
                        .then(() => {
                            console.log('data deleted: ', uid);
                        }),
                    db.ref("/configs_data/" + uid)
                        .remove()
                        .then(() => {
                            console.log('data deleted: ', uid)
                        })
                ]);
            });
            return Promise.all(promises).then(() => {
                return ref.once("value")
                    .then((snapshot) => {
                        let list = snapshot.val() || [];
                        let newList = list.filter(uid => !uids.includes(uid));
                        commit("deleteConfigs", uids);
                        return ref.set(newList);
                    });
            });
        },
        deleteMasterConfig({commit}, uid) {
            let db = firebase.database();
            return Promise.all([
                db.ref("/master/" + uid)
                    .remove()
                    .then(() => {
                        commit("deleteMasterConfig", uid);
                    }),
                db.ref("/configs_data/" + uid)
                    .remove()
                    .then(() => {
                        console.log('data master deleted: ', uid)
                    })
            ]);
        },
        updateMetadata({/*commit*/}, value){
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            var data = {};
            data["updated"] = TimeUtils.now();
            data["uid"] = user.uid;
            return db.ref("configs/" + value + "/meta")
                .update(data)
                .then(() => { })
        },
        updateReleaseConfig({commit}, value) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            value.config.meta = new Metadata(user.uid);
            let stack = []
            stack.push(
                db.ref("/release/" + value.config.uid)
                .set(serialize(ConfigModel, value.config)).then(() => {
                    console.log('updateReleaseConfig succes')
                    commit("updateReleaseConfig", value.config);
                }, (reason) => {
                    console.error("updateReleaseConfig failed: " + reason);
                }))
            if (value.data != null){
                stack.push(
                    db.ref("/configs_data/" + value.config.uid)
                    .set(value.data)
                    .then(() => {
                        console.log('updateReleaseConfig configs_data succes')
                    }, (reason) => {
                        console.error("updateReleaseConfig configs_data failed: " + reason);
                    }))
            }
            return Promise.all(stack)
        },
        removeReleaseConfig({commit}, uid) {
            let db = firebase.database();
            console.log("removeReleaseConfig", uid);
            return Promise.all([
                db.ref("/release/" + uid)
                    .remove()
                    .then(() => {
                        commit("removeReleaseConfig", uid);
                    }),
                db.ref("/configs_data/" + uid)
                    .remove()
                    .then(() => {
                        console.log('data release deleted: ', uid)
                    }),
            ]);
        },
        fetchMergeHistory({commit}, value) {
            let db = firebase.database();
            return db.ref("/merge_history/merge_list")
                .once("value")
                .then((snapshot) => {
                    let data = Object.values(snapshot.val() || {});
                    let values = data.map(v => deserialize(MergeHistoryModel, v));
                    commit("setMergeHistory", values);
                    return Promise.resolve();
                })
        },

        fetchReleaseConfigs({commit}) {
            let db = firebase.database();

            return db.ref("/release")
              .once("value")
              .then((snapshot) => {
                  let data = Object.values(snapshot.val() || {});
                  let values = data.map(v => deserialize(ConfigModel, v));
                  commit("setReleaseConfigs", values);
                  return Promise.resolve();
              });
        },
        fetchMasterConfigs({commit}) {
            let db = firebase.database();

            return db.ref("/master")
              .once("value")
              .then((snapshot) => {
                  let data = Object.values(snapshot.val() || {});
                  let values = data.map(v => deserialize(ConfigModel, v));
                  commit("setMasterConfigs", values);
                  return Promise.resolve();
              });
        },
        fetchSharedConfigs({commit}) {
            let db = firebase.database();
            return db.ref("/shared_configs")
                .once("value")
                .then((snapshot) => {
                    let data = Object.values(snapshot.val() || {});
                    let values = data.map(v => deserialize(ConfigModel, v));
                    commit("setSharedConfigs", values);
                    return Promise.resolve();
                });
        },
        pushSharedConfig({commit}, value) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            value.config.meta = new Metadata(user.uid);
            let data = serialize(ConfigModel, value.config);
            return Promise.all([
                db.ref("/shared_configs/" + value.config.uid)
                    .set(data)
                    .then(() => {
                        commit("updateSharedConfig", value.config);
                    }),
                db.ref("/configs_data/" + value.config.uid)
                    .set(value.data)
                    .then(() => {})
            ]);
        },
        updateSharedConfigMeta({commit}, config) {
            let user = firebase.auth().currentUser;
            let db = firebase.database();
            config.meta = new Metadata(user.uid);
            let data = serialize(ConfigModel, config);
            return db.ref("/shared_configs/" + config.uid)
                .set(data)
                .then(() => {
                    commit("updateSharedConfig", config);
                });
        },
        deleteSharedConfig({commit}, uid) {
            let db = firebase.database();
            return Promise.all([
                db.ref("/shared_configs/" + uid)
                    .remove()
                    .then(() => {
                        commit("removeSharedConfig", uid);
                    }),
                db.ref("/configs_data/" + uid)
                    .remove()
                    .then(() => {})
            ]);
        },
        findLinkedConfigs(_, sharedUid) {
            let db = firebase.database();
            let linked = [];
            return Promise.all([
                db.ref("/release").orderByChild("sharedConfig").equalTo(sharedUid).once("value"),
                db.ref("/configs").orderByChild("sharedConfig").equalTo(sharedUid).once("value"),
                db.ref("/master").orderByChild("sharedConfig").equalTo(sharedUid).once("value")
            ]).then(([releaseSnap, configsSnap, masterSnap]) => {
                if (releaseSnap.exists()) {
                    releaseSnap.forEach(child => {
                        let val = child.val();
                        linked.push({uid: child.key, name: val.group || child.key, path: "/release/" + child.key});
                    });
                }
                if (configsSnap.exists()) {
                    configsSnap.forEach(child => {
                        if (linked.find(l => l.uid === child.key)) return;
                        let val = child.val();
                        linked.push({uid: child.key, name: val.group || child.key, path: "/configs/" + child.key});
                    });
                }
                if (masterSnap.exists()) {
                    masterSnap.forEach(child => {
                        if (linked.find(l => l.uid === child.key)) return;
                        let val = child.val();
                        linked.push({uid: child.key, name: val.group || child.key, path: "/master/" + child.key});
                    });
                }
                return linked;
            });
        },
        unlinkSharedConfigs({dispatch}, linked) {
            let db = firebase.database();
            let unlinkPromises = linked.map(c =>
                db.ref(c.path + "/sharedConfig").remove()
            );
            return Promise.all(unlinkPromises).then(() => {
                let refreshes = [
                    dispatch("fetchReleaseConfigs"),
                    dispatch("fetchConfigs"),
                ];
                if (linked.some(c => c.path.startsWith("/master/"))) {
                    refreshes.push(dispatch("fetchMasterConfigs"));
                }
                return Promise.all(refreshes);
            });
        },
        setSharedConfigOnConfig(_, {path, sharedUid}) {
            return firebase.database()
                .ref(path + "/sharedConfig")
                .set(sharedUid);
        },
        getConfigMetadataPath(_, uid) {
            return firebase.database().ref("/release/" + uid).once("value").then(snap => {
                if (snap.exists()) return "/release/" + uid;
                return firebase.database().ref("/configs/" + uid).once("value").then(snap2 => {
                    if (snap2.exists()) return "/configs/" + uid;
                    return null;
                });
            });
        },
        getSharedConfigUidForConfig(_, configUid) {
            return firebase.database().ref("/release/" + configUid + "/sharedConfig").once("value")
                .then((snap) => {
                    if (snap.exists() && snap.val()) return snap.val();
                    return firebase.database().ref("/configs/" + configUid + "/sharedConfig").once("value")
                        .then((snap2) => (snap2.exists() && snap2.val()) ? snap2.val() : null);
                });
        },
        saveDeployedSource(_, {data, sharedConfigUid, sharedConfigData, storageName}) {
            let db = firebase.database();
            let key = storageName.replace(/\./g, '_dot_');
            let record = {
                data: data,
                sharedConfig: sharedConfigUid || null
            };
            if (sharedConfigData) {
                record.sharedConfigData = sharedConfigData;
            }
            return db.ref("/deployed_sources/" + key).set(record);
        },
        getDeployedSourceByName(_, storageName) {
            let db = firebase.database();
            let key = storageName.replace(/\./g, '_dot_');
            return db.ref("/deployed_sources/" + key).once("value")
                .then((snap) => {
                    if (!snap.exists() || !snap.val()) return null;
                    return snap.val();
                });
        },
        removeDeployedSource(_, storageName) {
            let db = firebase.database();
            let key = storageName.replace(/\./g, '_dot_');
            return db.ref("/deployed_sources/" + key).remove();
        },
    }
}

